module.exports = "/assets/hero-bfw_01.jpg?r3XjB+Q";